import {useState} from 'react';
import {Modal, Spinner} from 'react-bootstrap';

import './LoaderOverlay.scss';

export type SpinnerOverlayProps = {
    showLoader: boolean
}

const SpinnerOverlay = (props: SpinnerOverlayProps) => {
    const [showLoader, setShowLoader] = useState(false);

    if (showLoader !== props.showLoader) {
        setTimeout(() => setShowLoader(props.showLoader), 200);
    }

    return <Modal animation={false} backdrop={false} dialogClassName="loader-overlay" contentClassName="loader-content" show={showLoader}
                  onHide={() => {
                      return;
                  }}>
        <Modal.Body>
            <Spinner className="spinner" animation="border" role="status" variant="danger">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </Modal.Body>
    </Modal>;
};

export default SpinnerOverlay;
